import { useState } from "react"


import DateRangePicker from "../../../Shared/Components/UI/ThePageElements/DatePicker";
import { AddToListProductSearchByLandingPageCategoryBarChart } from "../../../components/PortalComponent/PortalDataVisualization/SearchEvents/AddToListProductSearchByLandingPageCategoryBarChart";
import { SelectProductSearchByLandingPageCategoryBarChart } from "../../../components/PortalComponent/PortalDataVisualization/SearchEvents/SelectProductSearchByLandingPageCategoryBarChart";
import { SelectProductSearchByLandingPageBarChart } from "../../../components/PortalComponent/PortalDataVisualization/SearchEvents/SelectProductsSearchByLandingPageBarChart";
import { AddToListSearchByLandingPageBarChart } from "../../../components/PortalComponent/PortalDataVisualization/SearchEvents/AddToListSearchByLandingPageBarChart";
import { SearchProductsSelectedLeaderBoard } from "../../../components/PortalComponent/PortalDataVisualization/SearchEvents/SearchProductsSelectedLeaderBoard";
import { SearchQueriesUsedWhenAddingProductToListLeaderBoard } from "../../../components/PortalComponent/PortalDataVisualization/SearchEvents/SearchQueriesUsedWhenAddingProductToListLeaderBoard";
import { SearchQueriesUsedWhenProductSelectedLeaderBoard } from "../../../components/PortalComponent/PortalDataVisualization/SearchEvents/SearchQueriesUsedWhenProductSelectedLeaderBoard";
import { SearchProductsAddedLeaderBoard } from "../../../components/PortalComponent/PortalDataVisualization/SearchEvents/SearchProductsAddedLeaderBoard";
import { SearchTypePieChart } from "../../../components/PortalComponent/PortalDataVisualization/SearchEvents/SearchTypePieChart";
import { AddToListSearchEventsByDateAreaChart } from "../../../components/PortalComponent/PortalDataVisualization/SearchEvents/AddToListSearchEventsByDateAreaChart";
import { SelectProductSearchEventsByDateAreaChart } from "../../../components/PortalComponent/PortalDataVisualization/SearchEvents/SelectProductSearchEventsByDateAreaChart";
import LGAppDataTiles from "../../PortalComponents/DisplayData/LGAppTrafficDataTiles";
import LGAppTrafficTable from "../../PortalComponents/DisplayData/LGAppTrafficTable"
import HDAppTrafficTable from "../../PortalComponents/DisplayData/HDAppTrafficTable"
import { PortalBanner } from "../../../components/PortalComponent/PortalPageComponent/PortalBanner/PortalBanner";

import HDAppTrafficDataTiles from "../../PortalComponents/DisplayData/HDAppTrafficDataTiles";
import SavedListsDataTiles from "../../PortalComponents/DisplayData/SavedListsDataTiles";

import PopularSavedListProductsTable from "../../PortalComponents/DisplayData/PopularSavedListProductsTable";
// import CustomEmailListsDataTiles from "../../PortalComponents/VisualElements/CustomEmailListsDataTiles";
// import CustomPrintListsDataTiles from "../../PortalComponents/VisualElements/CustomPrintListsDataTiles";

// import CustomSearchDataTiles from "../../PortalComponents/VisualElements/CustomSearchDataTiles";

// import WebsiteTrafficTable from "../../PortalComponents/VisualElements/WebsiteTrafficTable";

import styles from "./AnalyticsPage.module.css"

import TheTableHeader from "../../PortalComponents/TableElements/TheTableHeader";

import ProductInventoryGraphs from "../../PortalComponents/DisplayData/ProductInventoryGraphs";
import { useAdminHook } from "../../../Hooks/use-context-hooks";
import { SearchEventsByDateAreaChart } from "../../../components/PortalComponent/PortalDataVisualization/SearchEvents/SearchEventsByDateAreaChart";

const AnalyticsPage = () => {

    const {

        startDate, endDate, setStartDate, setEndDate,
        isFilteredGoogleAnalyticsData,
        isPortalDataState
    } = useAdminHook();


    const [showTable, setShowTable] = useState({
        lgTrafficTable: false,
        hdTrafficTable: false,
        popularSavedListTable: false,
    })

    const showLGTableHandler = () => {
        setShowTable(prevState => ({ ...prevState, lgTrafficTable: !prevState.lgTrafficTable }))
    }
    const showHDTableHandler = () => {
        setShowTable(prevState => ({ ...prevState, hdTrafficTable: !prevState.hdTrafficTable }))
    }
    const showPopulartSavedListTableHandler = () => {
        setShowTable(prevState => ({ ...prevState, popularSavedListTable: !prevState.popularSavedListTable }))
    }
    // const dateHourMinutes = isPortalDataState.userData.map(user => user.dateHourMinute);

    // console.log();
    return (

        <div>
            <DateRangePicker
                startDate={startDate}
                endDate={endDate}
                handleStartDateChange={setStartDate}
                handleEndDateChange={setEndDate}
            />
            <TheTableHeader
                title="Analytics"
                subtitle="Product Guide Overview"
                headline="Statistics and Insights on website traffic and user behaviours"
            />

            <PortalBanner
                title='Search Activity'
                subtitle="Product Search Analytics "
                row1={
                    <>
                        <SearchEventsByDateAreaChart />
                        <AddToListSearchEventsByDateAreaChart />
                        <SelectProductSearchEventsByDateAreaChart />
                        <SearchTypePieChart />

                    </>
                }
                row2Chart1={
                    <>
                        <SearchProductsAddedLeaderBoard />
                        <SearchQueriesUsedWhenProductSelectedLeaderBoard />

                    </>
                }
                row2Chart2={
                    <>
                        <SearchProductsSelectedLeaderBoard />
                        <SearchQueriesUsedWhenAddingProductToListLeaderBoard />
                    </>
                }
                row3Chart1={
                    <>
                        <AddToListSearchByLandingPageBarChart />
                        <SelectProductSearchByLandingPageBarChart />
                    </>
                }
                row3Chart2={
                    <>
                        <AddToListProductSearchByLandingPageCategoryBarChart />
                        <SelectProductSearchByLandingPageCategoryBarChart />
                    </>
                }
            />

            <section>
                <div className={styles.textBox}>
                    <p className={styles.titleText}>LG Product Guide</p>
                    <div onClick={showLGTableHandler}>SHOW TABLE</div>
                </div>
                <LGAppDataTiles />
                {/* <div onClick={showLGTableHandler}>SHOW TABLE</div> */}
                {showTable.lgTrafficTable && <LGAppTrafficTable />}
            </section>
            <section>
                <div className={styles.textBox}>
                    <p className={styles.titleText}>Home Depot Product Guide</p>
                    <div onClick={showHDTableHandler}>SHOW TABLE</div>
                </div>
                <HDAppTrafficDataTiles />

                {showTable.hdTrafficTable && <HDAppTrafficTable />}
            </section>
            <section>
                <div className={styles.textBox}>
                    <p className={styles.titleText}>Product List Engagement</p>
                    <div onClick={showPopulartSavedListTableHandler}>SHOW TABLE</div>
                </div>
                <SavedListsDataTiles />
                {/* <CustomPrintListsDataTiles />
                <CustomEmailListsDataTiles />
                <CustomSearchDataTiles /> */}

                {showTable.popularSavedListTable && <PopularSavedListProductsTable />}
            </section>

            <section>
                <div className={styles.textBox}>
                    <p className={styles.titleText}>Product Inventory</p>
                </div>
                <ProductInventoryGraphs />

            </section>



            <div className={styles.pageHeaderContainer}></div>

        </div>
    )
}

export default AnalyticsPage;